import {Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {DisplayType} from '@catuiform/types';
import {DomHandler} from 'primeng/primeng';

const componentBaseName = 'text-only';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

/**
 * A component to provide a normalized way to display a label / text pair.
 * Used to display readonly values in forms
 */
@Component({
  selector: 'cat-text-only',
  templateUrl: './text-only.component.html',
  styleUrls: ['./text-only.component.scss'],
})
export class TextOnlyComponent implements OnInit {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() label: string;
  @Input() value: string | number;
  @Input() type: DisplayType = DisplayType.grid;

  @Output() click = new EventEmitter();

  types = DisplayType;
  constructor() {
  }

  ngOnInit() {
  }

  onClick($event) {
    this.click.emit($event);
  }

  get isLink() {
    return this.click.observers.length > 0;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/components/text-only/text-only.component.ts